// browser's onTimeUpdate event provides a precision of 6 decimal places:
export function toAudioPrecision(time, durationInSeconds) {
  return Math.floor(Math.pow(10, 6) * Math.min(time, durationInSeconds)) / Math.pow(10, 6);
}
export function tryUseMono(node) {
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  // Compatibility note: Safari 6+ Implemented with the vendor prefix: webkit, available on user interaction which is the current usecase

  if (AudioContext) {
    const audioCtx = new AudioContext();
    const source = audioCtx.createMediaElementSource(node);
    const splitter = audioCtx.createChannelSplitter(2);
    source.connect(splitter);
    const gainNodeLeft = audioCtx.createGain();
    splitter.connect(gainNodeLeft, 0);
    const gainNodeRight = audioCtx.createGain();
    splitter.connect(gainNodeRight, 1);

    // Reduce the volume so the mix is not too high
    gainNodeLeft.gain.setValueAtTime(0.6, audioCtx.currentTime);
    gainNodeRight.gain.setValueAtTime(0.6, audioCtx.currentTime);

    // Connect both input channels to both output channels
    const merger = audioCtx.createChannelMerger(2);
    gainNodeLeft.connect(merger, 0, 0);
    gainNodeLeft.connect(merger, 0, 1);
    gainNodeRight.connect(merger, 0, 0);
    gainNodeRight.connect(merger, 0, 1);
    merger.connect(audioCtx.destination);
  }
}